import { ThemeColorVariable, ThemeStyleProps } from "@caspeco/casper-ui-library.base-ui.theme";
import { Text } from "@caspeco/casper-ui-library.components.text";
import { useTranslation } from "react-i18next";

const WaitListTimeSetTitle = (props: ThemeStyleProps) => {
    const { t } = useTranslation();

    return (
        <Text color={ThemeColorVariable.OnBackgroundHeader} fontWeight="500" {...props}>
            {t("waitList.timesWithWaitList")}
        </Text>
    );
};

export default WaitListTimeSetTitle;
